import { Injectable } from '@angular/core';
import { SmartyCubeStorageKeys } from '@core/config/smartycube-storage-keys';
import { Urls } from '@core/config/urls';
import { LegacyBaseApiService, LocalStorageService, RestClientService } from '@smartera/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class TokenService {
	public isTokenExpired = new Subject<boolean>();

	constructor(private restClientService: RestClientService) {
		this.isTokenExpired.next(false);
	}

	get apiUrl() {
		return environment.baseURL.toString() + '/sec/sessions';
	}

	public close() {
		this.restClientService.delete(`${this.apiUrl}/close`).toPromise();
		this.isTokenExpired.complete();
	}

	public unlockUser2Fa(code: any): Observable<void> {
		return this.restClientService.post(`${this.apiUrl}/unlock-user-2fa`, JSON.stringify(code));
	}

	public resend2Fa(): Observable<void> {
		return this.restClientService.get(`${this.apiUrl}/resend-user-2fa-code`);
	}
}
